import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * 페이지 진입 시 스크롤을 최상단으로 이동시키는 커스텀 훅
 *
 * @example
 * ```tsx
 * const MyPage = () => {
 *   useScrollToTop()
 *
 *   return <div>...</div>
 * }
 * ```
 */
export const useScrollToTop = () => {
  const location = useLocation()

  useEffect(() => {
    // 페이지 경로가 변경될 때마다 스크롤을 맨 위로 이동
    window.scrollTo(0, 0)
  }, [location.pathname])
}
